module.exports = __webpack_public_path__ + "img/1440.8fb66b14.svg";